import _webScan from "../../../../componets/_webScan";
import React from "react";
import Params from "../../../../componets/_params";
import apiEndPoints from "../../../../componets/json/apiEndPoints.json";
class WebScanPage extends React.Component {
  state = {
    files: [],
    docno: -1,
    setDoc: false,
  };

  saveFileToDoc = async () => {
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: apiEndPoints.britex.internal.service.webscan.method,
      data: this.state.files,
      endpoint: apiEndPoints.britex.internal.service.webscan.endPoint.replace(
        "{docno}",
        this.state.docno
      ),
      param: "",
    });
    this.setState({ loading: false });
    if (_res.status === 200) this.setState({ files: [] });
  };

  setModalDoc = async () => {
    if (this.state.docno.length >= 7) {
      this.props.setNavigate("/apps/webscan/" + this.state.docno);
      this.setState({ setDoc: false });
    }
  };

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: (
        <this.props._icon
          mdoutlinefilepresent
          className="c-placeholder c-green"
        />
      ),
      Title: "Scany do zakázky",
      SubTitle: "",
    });
    if (this.props.params.id && !this.state._main)
      this.setState({
        docno: this.props.params.id === ":id" ? "" : this.props.params.id,
        setDoc: this.props.params.id === ":id" ? true : false,
      });
  }

  render() {
    const { SIZE, Bs } = this.props;
    return (
      <>
        {this.state.setDoc && (
          <Bs
            modal
            show={true}
            onHide={() => this.props.setNavigate("/")}
            keyboard={true}
            backdrop="static"
            centered
            size={SIZE.LG}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Bs modalheader>Zadej číslo zakázky do které se bude scanovat</Bs>
            <Bs modalbody>
              <Bs formtext>Číslo zakázky</Bs>
              <Bs
                formcontrol
                value={this.state.docno}
                onChange={(e) => this.setState({ docno: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") this.setModalDoc();
                }}
              />
            </Bs>
            <Bs modalfooter>
              <Bs
                button
                variant={"success"}
                disabled={this.state.docno.length < 7}
                onClick={this.setModalDoc}
                size={SIZE.SM}
              >
                Potvrdit
              </Bs>
            </Bs>
          </Bs>
        )}
        {!this.state.setDoc && (
          <Bs
            modal
            show={true}
            onHide={() => this.props.setNavigate("/")}
            keyboard={true}
            backdrop="static"
            centered
            size={SIZE.LG}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Bs modalheader closeButton>
              <Bs col className="d-flex justify-content-between">
                <Bs span>Scany do zakázky {this.state.docno}</Bs>
                <Bs
                  button
                  variant={"success"}
                  onClick={this.saveFileToDoc}
                  size={SIZE.SM}
                >
                  Uložit do zakázky
                </Bs>
              </Bs>
            </Bs>
            <Bs modalbody>
              <_webScan
                {...this.props}
                webCam={true}
                docType={true}
                docTypeFilter={"3,4,5,10,12,15"}
                twain={false}
                hdr={true}
                mobile={true}
                files={this.state.files}
                setFiles={(e) => this.setState({ files: e })}
                setMobile={(e) => this.setState({ files: e })}
                onKeyDown={(e) => this.setState({ files: e })}
              />
            </Bs>
          </Bs>
        )}
      </>
    );
  }
}

export default Params(WebScanPage);
